import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Button } from "../../ui/button";
import { Plus } from "lucide-react";

export const TravelCostForm = ({ form, setForm, editingId, saving, onSubmit, onCancel }) => (
  <div className="border-t pt-4 space-y-3">
    <p className="text-sm font-medium">{editingId ? "Editar zona" : "Nueva ciudad o zona"}</p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div>
        <Label>Ciudad o zona</Label>
        <Input data-testid="admin-travel-cost-form-city" value={form.city} onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))} placeholder="Ej. San Miguel de Allende" />
      </div>
      <div>
        <Label>Costo de viáticos (MXN)</Label>
        <Input data-testid="admin-travel-cost-form-price" type="number" value={form.price} onChange={(e) => setForm((f) => ({ ...f, price: e.target.value }))} placeholder="Ej. 500" />
      </div>
    </div>
    <div className="flex gap-2">
      <Button data-testid="admin-travel-cost-submit-button" onClick={onSubmit} disabled={saving}>
        <Plus size={16} className="mr-1" /> {editingId ? "Guardar cambios" : "Agregar zona"}
      </Button>
      {editingId && (
        <Button data-testid="admin-travel-cost-cancel-edit" variant="outline" onClick={onCancel}>Cancelar</Button>
      )}
    </div>
  </div>
);
